<script setup>
defineProps({
  color: {
    type: String,
    default: '#3b82f6',
  },
  size: {
    type: String,
    default: 'size-2',
  },
})
</script>

<template>
  <span
    class="shrink-0 rounded-full"
    :class="size"
    :style="{ backgroundColor: color }"
    aria-hidden="true"
  />
</template>
